import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NewNavigationBar from '@surfline/quiver-react/dist/NewNavigationBar';
import FavoritesBar from '@surfline/quiver-react/dist/FavoritesBar';
import Notification from '@surfline/quiver-react/dist/Notification';
import CTA from '@surfline/quiver-react/dist/SurflinePageContainer/CTA';
import entitlementsPropType from '@surfline/quiver-react/dist/PropTypes/entitlementsPropType';
import favoritesPropType from '@surfline/quiver-react/dist/PropTypes/favoritesPropType';
import userPropType from '@surfline/quiver-react/dist/PropTypes/userPropType';
import settingsPropType from '@surfline/quiver-react/dist/PropTypes/settingsPropType';
import HeroAdUnit from './HeroAdUnit';
import NotificationBarController from '../NotificationBarController';
import { HERO_AD_PLACEHOLDER } from '../../../common/treatments';
import config from '../../../config/';

class Header extends Component {
  /**
   * Check if the current user is a premium user and not being given premium by open house
   * @param {Array<string>} entitlements
   */
  isPremium = entitlements =>
    entitlements.indexOf('sl_premium') > -1 && entitlements.indexOf('sl_promotional') === -1;

  render() {
    const {
      settings,
      details: user,
      favorites: {
        data: {
          favorites,
        },
      },
      renderOptions,
      openHouse,
      features: {
        treatments: {
          [HERO_AD_PLACEHOLDER]: heroAdPlaceholder,
        },
      },
    } = this.props;
    const entitlements = this.props.entitlements ? this.props.entitlements.entitlements : [];
    const isPremium = this.isPremium(entitlements);
    const freeTrialEligible = this.props.entitlements && this.props.entitlements.promotions.indexOf('sl_free_trial') > -1;
    const largeFavoritesBar = !!renderOptions.largeFavoritesBar;
    const hideCTA = renderOptions.hideCTA === 'true';

    const smallNotification = (
      <Notification type="small" level="information">
        <CTA className="quiver-notification__cta" ctaLocation="button top">
          GO PREMIUM
        </CTA>
      </Notification>
    );

    return (
      <div>
        {renderOptions.bannerAd === 'true' ? (
          <HeroAdUnit
            user={user}
            entitlements={entitlements}
            qaFlag={renderOptions.qaFlag}
            placeholder={heroAdPlaceholder}
          />
        ) : null}
        {!hideCTA ?
          <NotificationBarController
            isPremium={isPremium}
            openHouse={openHouse}
            user={user}
          /> : null }
        <NewNavigationBar
          user={user}
          favorites={favorites}
          settings={settings}
          smallNotification={smallNotification}
          hideCTA={hideCTA}
          entitlements={entitlements}
          serviceConfig={{
            serviceUrl: config.servicesURL,
          }}
          freeTrialEligible={freeTrialEligible}
        />
        <FavoritesBar
          settings={settings}
          favorites={favorites}
          user={user}
          large={largeFavoritesBar}
        />
        <div id="backplane-header-open-house" />
      </div>
    );
  }
}

Header.propTypes = {
  entitlements: PropTypes.shape({
    entitlements: entitlementsPropType,
    promotions: PropTypes.array,
  }),
  favorites: PropTypes.shape({
    data: PropTypes.shape({
      favorites: favoritesPropType,
    }),
  }),
  details: userPropType,
  settings: settingsPropType,
  renderOptions: PropTypes.shape({
    largeFavoritesBar: PropTypes.string,
    qaFlag: PropTypes.string,
    bannerAd: PropTypes.oneOf(['true', 'false']),
    hideCTA: PropTypes.oneOf(['true', 'false']),
  }),
  openHouse: PropTypes.shape({
    active: PropTypes.bool.isRequired,
    data: PropTypes.shape({
      banner: PropTypes.shape({
        copy: PropTypes.string.isRequired,
        creative: PropTypes.shape({
          '1x': PropTypes.string.isRequired,
          '2x': PropTypes.string,
          '3x': PropTypes.string,
        }).isRequired,
      }),
    }),
  }).isRequired,
  features: PropTypes.shape({
    treatments: PropTypes.shape({
      hero_ad_placeholder: PropTypes.string,
    }),
  }).isRequired,
};

Header.defaultProps = {
  details: null,
  settings: null,
  entitlements: { entitlements: [], promotions: [] },
  children: <div />,
  serviceConfig: null,
  favorites: { data: { favorites: [] } },
  renderOptions: {
    largeFavoritesBar: null,
    qaFlag: null,
    bannerAd: 'false',
    hideCTA: 'false',
  },
};

export default Header;



// WEBPACK FOOTER //
// ./src/bundles/margins/Header/Header.js